<template>
  <div class="pannel7">
    <!-- 标题-->
    <NavTiltle :titleNav="title" :titleTextNav="titleText" />
    <!-- PC -->
    <div class="pc-conent">
      <div class="img-box">
        <div class="img-box-item" v-for="adv in techAdvances" :key="adv.id">
          <growCard :advname="adv" :flagtxt="true"></growCard>
        </div>
      </div>
    </div>
    <!-- moblie  :flagtxt="false"-->
    <el-row class="gallery">
      <el-col
        v-for="(adv, idx) in techAdvances"
        :key="adv.id"
        @click.native="dec(idx)"
        :xs="idx != techAdvances.length - 1 ? 24 : 24"
        :sm="idx != techAdvances.length - 1 ? 24 : 24"
        :md="idx != techAdvances.length - 1 ? 24 : 24"
      >
        <growCard
          :advname="adv"
          style="flex-direction: row-reverse"
          :flagtxt="false"
          class="moblie-card"
        ></growCard>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import NavTiltle from "../components/NavTiltle.vue";
import growCard from "../components/growCard.vue";
export default {
  name: "Pannel7",
  data() {
    return {
      sci: 0,
      title: "生态落地",
      titleText: "ECOLOGICAL LANDING",
      techAdvances: [
        {
          name: "阿里",
          path: require("./../assets/images/生态落地/1.png"),
          id: 1,
          dec:
            "与阿里巴巴集团开展了深度合作，无缝对接，并荣获阿里巴巴开发者大赛美业应用第一名。",
        },
        {
          name: "有赞",
          path: require("./../assets/images/生态落地/2.png"),
          id: 2,
          dec:
            "有赞环境可直接部署，美到家是有赞平台优秀第三方合作伙伴，荣获有赞认证开发者称号，并成为有赞零售、美业等多个业务线的长期的战略合作伙伴。",
        },
        {
          name: "京东",
          path: require("./../assets/images/生态落地/3.png"),
          id: 3,
          dec:
            "京东商城一键上线，成为京东京麦服务市场唯一的AI美业类服务软件提供商，将为京东百万商家提供优质稳定的美业AI营销服务。",
        },
        {
          name: "其他",
          path: require("./../assets/images/生态落地/4.png"),
          id: 4,
          dec:
            "网络私域流量、智能硬件、线下场景均可部署，如果您需要在自身APP、小程序、硬件中使用该技术，都可以进行部署和实现。",
        },
      ],
    };
  },
  components: {
    NavTiltle,
    growCard,
  },
  methods: {
    dec(ind) {
      this.sci = ind;
      console.log(this.techAdvances[ind].path, ind);
    },
  },
};
</script>

<style lang="less" scoped>
.pannel7 {
  width: 100%;
  height: auto;
  .pc-conent {
    background: #f5f2f5;
    box-sizing: border-box;
    // padding: 0 10px 50px;
    // padding: 0 10% 0;
    padding: 0 200px 100px 200px;
    width: 100%;
    height: 100%;
    .img-box {
      width: 100%;
      height: 400px;
      display: flex;
      flex-wrap: wrap;
      .img-box-item {
        width: 48%;
        // height: 200px;
        height: auto;
        /deep/.group-card .img-box {
          // filter: blur(3px);
        }
        /deep/ .group-card .flex-box {
          .mdjadvText {
            margin-left: 37px;
          }
        }

        &:hover {
          /deep/.group-card .img-mark {
            display: none;
          }
          /deep/ .group-card .img-box {
            width: 200px;
            height: 200px;
            margin-top: 20px;
            top: 100%;
            transform: translateY(-90%);
            // filter: blur(0);
          }
          /deep/ .group-card .flex-box {
            height: 230px;
            background: linear-gradient(
              138deg,
              #ee0090 0%,
              #e84142 100%,
              #e84142 100%
            );
            opacity: 1;
            color: #fff;
            .small {
              color: #fff;
            }
            .small-icon {
              transform: translate(-10px, 10px) rotate(45deg);
              background: #ffffff !important;
              // transform: rotate(45deg);
              //     transform: translate(-13px, 10px);
            }
          }
        }
      }
    }
  }
  .gallery {
    display: none;
  }
}
@media only screen and (min-width: 992px) {
  .el-col-md-4 {
    display: inline-block;
    width: 20%; // 重置宽度为 1/5
  }
}
@media screen and (max-width: 1024px) {
  .pannel7 {
    width: 100%;
    .gallery {
      box-sizing: border-box;
      padding: 0 0 50px 0;
      display: block;
      background: #f5f2f5;
      .moblie-card {
        width: 100%;
        height: 118px;
        box-sizing: border-box;
        padding: 0 20px;
        margin-top: 20px;
        /deep/ .group-card {
          width: 100%;
          height: 118px;
        }

        /deep/ .group-card .flex-box .small {
          // width: 40px;
          // height: 10px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          letter-spacing: 5px;
        }
        // 图片
        /deep/ .group-card .img-box {
          width: 107px;
          height: 107px;
          position: relative;
          left: 0;
          top: 50%;
          -webkit-transform: translateY(-48%);
          transform: translateY(-48%);
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        // 文字
        /deep/ .group-card .flex-box {
          width: 218px;
          height: 85px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          // line-height: 16px;
          letter-spacing: 2px;
        }
      }
    }
    .pc-conent {
      display: none;
    }
  }
}
</style>
